__turbopack_context__.v({
  "addItemButton": "_1Jmxqq_addItemButton",
  "container": "_1Jmxqq_container",
  "dragHandleContainer": "_1Jmxqq_dragHandleContainer",
  "icon": "_1Jmxqq_icon",
  "immutable": "_1Jmxqq_immutable",
  "isDragging": "_1Jmxqq_isDragging",
  "itemContainer": "_1Jmxqq_itemContainer",
  "lineTotalContainer": "_1Jmxqq_lineTotalContainer",
  "lineTotalMobileLabel": "_1Jmxqq_lineTotalMobileLabel",
  "lineTotalValue": "_1Jmxqq_lineTotalValue",
  "name": "_1Jmxqq_name",
  "notes": "_1Jmxqq_notes",
  "quantity": "_1Jmxqq_quantity",
  "rate": "_1Jmxqq_rate",
  "remove": "_1Jmxqq_remove",
  "showNotes": "_1Jmxqq_showNotes",
  "taxPercentage": "_1Jmxqq_taxPercentage",
});
